import React, { useState, useEffect } from "react";

import { InputSwitch } from "primereact/inputswitch";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
const Modules = (props) => {
  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (props?.fields) {
      setFields(props?.fields);
    }
  }, [props.fields]);

  useEffect(() => {
    props.getData(fields);
  }, [fields]);

  const [placeholders, setPlaceholders] = useState({
    currentPassword: props?.fields.display_name,
  });

  const handleToggle = (field) => {
    setFields((prevFields) => ({
      ...prevFields,
      status: !field,
    }));
  };
  const handlePlaceholderChange = (value) => {
    setFields((prevFields) => ({
      ...prevFields,
      display_name: value,
    }));
  };

  return (
    <div>
      <div className="new-field">
        <div className="form-group row align-items-center mb-0 mt-0">
          <div className="col-md-4 pl-0">
            <label className="text-xs">{props?.fields?.ESG_module_name}</label>
          </div>
          <div className="col-md-1 pl-0">
            <InputSwitch
              checked={fields.status}
              onChange={() => handleToggle(fields.status)}
            />
          </div>
          <div className='col pr-0'>
            <InputTextElementElement
              disabled={!fields.status}
              value={fields.display_name}
              onChange={(e) => handlePlaceholderChange(e.target.value)}
              placeholder={fields.display_name}
              className='w-full'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modules;
